import { isEqual } from "lodash";
import React from "react";
import { withRouter } from "react-router";

@withRouter
class ScrollToTop extends React.Component {
  previousStripedLocation = null;

  componentDidMount(): void {
    const { history } = this.props;

    this.unListenHistory = history.listen(newLocation => {
      const state = newLocation.state;

      const skipScrollToTop = state?.skipScrollToTop;
      if (skipScrollToTop) {
        return;
      }

      const stripedLocation = {
        hash: "",
        key: "",
        pathname: newLocation.pathname,
        search: newLocation.search,
        state: ""
      };

      if (!isEqual(stripedLocation, this.previousStripedLocation)) {
        window.scrollTo(0, 0);
      }

      this.previousStripedLocation = stripedLocation;
    });
  }

  componentWillUnmount() {
    this.unListenHistory();
  }

  render() {
    const { children } = this.props;

    return children;
  }
}

export default ScrollToTop;
